import React from 'react';
import {
  List,
  Create,
  SimpleForm,
  AutocompleteInput,
  ReferenceInput,
  FunctionField,
  ReferenceArrayInput,
  CheckboxGroupInput,
  Datagrid,
  Filter,
  TextInput,
  TextField,
  SelectInput,
  translate as t,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import DeleteButton from '../components/button/DeleteButton';
import { ChipRender } from '../components/fields/ChipArrayField';

import { getTranslationByLocale } from '../utils/TranslationUtils';

const Title = t(({ record, locale }) => (getTranslationByLocale(record.title, locale)));

const LockedProductFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label="Market" source="market" reference="markets" allowEmpty alwaysOn>
      <SelectInput optionValue="id" optionText={<Title {...props} />} />
    </ReferenceInput>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);

export const LockedProductList = (props) => (
  <List
    {...props}
    perPage={20}
    filters={<LockedProductFilter />}
    filter={
      { 'markets.locked': true }
    }
  >
    <Datagrid>
      <TextField source="internalName" />
      <FunctionField label="Locked in" render={(record) => ChipRender(record, 'locked')} />
      <DeleteButton {...props} basePath="/lockedProducts" />
    </Datagrid>
  </List>
);

export const LockedProductCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <ReferenceInput source="product" reference="products" allowEmpty filter={{ provisional: { $ne: true }, frozen: { $ne: true } }}>
        <AutocompleteInput optionText="internalName" options={{ fullWidth: true }} />
      </ReferenceInput>
      <ReferenceArrayInput source="markets" reference="markets" allowEmpty>
        <CheckboxGroupInput optionText="countryCode" optionValue="countryCode" />
      </ReferenceArrayInput>
    </SimpleForm>
  </Create>
);

export const LockedProductEdit = (props) => (
  <Edit {...props} resource="products">
    <SimpleForm>
      <ReferenceArrayInput source="markets" reference="markets" allowEmpty>
        <CheckboxGroupInput optionText="countryCode" optionValue="countryCode" />
      </ReferenceArrayInput>
    </SimpleForm>
  </Edit>
);
